export default __webpack_public_path__ + "static/media/tall-trestle.ad376a8e.svg";